

















































































































































import { Component, Prop, Vue, Watch, Mixins } from 'vue-property-decorator'
import { columns } from './config'
import TaskApi from '@/api/task'
import bus from './bus'
import { insuranceTypeAuthList } from './authConfig'
import echarts from 'echarts/index.common'
import 'echarts/map/js/china.js'

@Component({})
export default class RelationsOrders extends Vue {
	@Prop()
	private data!: any

	@Prop()
	private resurveyOrder!: any

	@Watch('data')
	private onDataChange() {
		this.addForm.resetFields()
	}

	private get step1List() {
		return insuranceTypeAuthList.filter((item: any) => this.$auth(item.authStr))
	}

	private get subInsuranceTypeList() {
		return this.$store.state.setting.subinsuranceTypeList
	}

	private addForm: any = {}

	private area: any = []

	private currentArea = -1

	private inputArea = ''

	private resultArea: any = []

	private async created() {
		this.addForm = this.$form.createForm(this)
		const res = await TaskApi.getVisitorAreaDistribution('')
		const data = res.data
		this.area = data
		this.resultArea = data
		this.renderMap(data)
	}

	private toggleDetail(index: number) {
		if (this.currentArea === index) {
			this.currentArea = -1
		} else {
			this.currentArea = index
		}
	}

	private onClear() {
		this.inputArea = ''
		this.resultArea = this.area
	}

	private onSearch() {
		this.currentArea = -1
		let reg = new RegExp(this.inputArea)
		this.resultArea = this.area.filter((item: any) => {
			return this.searchArea(item, reg)
		})
		if (this.resultArea && this.resultArea.length) {
			this.currentArea = 0
		}
	}

	private searchArea(area: any, reg: RegExp) {
		if (area.areaName && area.areaName.match(reg)) {
			return true
		}
		let res = ''
		res =
			area.children &&
			area.children.find((item: any) => {
				return this.searchArea(item, reg)
			})
		return res
	}

	private onRadioChange() {
		this.addForm.setFieldsValue({
			subInsuranceType: '',
		})
		if (this.resurveyOrder) {
			this.$nextTick(() => {
				this.addForm.setFieldsValue({
					insuranceType: this.resurveyOrder.insuranceType,
					subInsuranceType: this.resurveyOrder.subInsuranceType,
				})
				this.nextStep()
			})
		} else {
			setTimeout(() => {
				this.nextStep()
			}, 0)
		}
	}

	private onSubRadioChange() {
		setTimeout(() => {
			this.addForm.setFieldsValue({
				insuranceType: '03',
			})
			this.nextStep()
		}, 0)
	}

	private renderMap(data: any) {
		this.$nextTick(() => {
			const map = document.getElementById('map')
			if (!map) {
				return
			}
			var myChart = echarts.init(map)
			const option = {
				title: {
					text: '作业覆盖区域',
				},
				series: [
					{
						type: 'map',
						map: 'china',
						label: {
							show: true,
						},
						silent: true,
						emphasis: {
							itemStyle: {
								areaColor: '#0064DC',
							},
						},
						data: data.map((item: any) => {
							let name = ''
							if (['黑龙江', '内蒙古'].includes(item.areaName.slice(0, 3))) {
								name = item.areaName.slice(0, 3)
							} else {
								name = item.areaName.slice(0, 2)
							}
							return {
								name,
								selected: true,
							}
						}),
					},
				],
			}

			myChart.setOption(option)
		})
	}

	private nextStep() {
		const {
			addForm: { validateFields },
		} = this
		// 先校验，通过表单校验后，才进入下一步
		validateFields((err: any, values: any) => {
			if (!err) {
				this.$emit('nextStep', values)
			}
		})
	}
}
